import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { graphqlProvider } from '../providers/graphql.provider';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DynamicScriptLoaderService } from './paymnets/dynamic-script-loader.service';
import { PaymentsService } from './paymnets/payments.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideHttpClient(), 
    graphqlProvider,
    provideAnimationsAsync(),
    DynamicScriptLoaderService,
    PaymentsService
  ]
};
